import { createSelector } from 'reselect'

import { selectAgentsByIdIncludingArchived } from 'selectors/agents/base'
import { selectGroupsById } from 'selectors/app/groups'
import { selectCurrentUser } from 'ducks/currentUser/selectors'
import {
  selectCurrentTicketId,
  selectHost,
  selectIsInChat,
} from 'selectors/location'
import selectCurrentConversationId from 'ducks/searches/selectors/selectCurrentConversationId'

import { selectTicketsById, selectRawById } from './byId'
import { decorateForInspector } from './shared/util'

export { selectCurrentTicketId }

export const selectCurrentTicketUndecorated = createSelector(
  selectRawById,
  selectCurrentTicketId,
  (byId, id) => {
    return byId[id] || null
  }
)

export const selectCurrentTicket = createSelector(
  selectTicketsById,
  selectCurrentTicketId,
  selectAgentsByIdIncludingArchived,
  selectCurrentUser,
  selectGroupsById,
  (
    byId,
    ticketId,
    agentsById,
    currentUser,
    ratingsByMessageId,
    readReceiptsByMessageId,
    customersById,
    groupsById
  ) => {
    if (ticketId === 'new')
      return {
        id: 'new',
        actions: { records: [] },
      }
    if (!ticketId) return null
    const found = byId[ticketId]
    if (found) {
      return decorateForInspector(agentsById, currentUser, groupsById)(found)
    }
    return null
  }
)

export const selectCurrentTicketGqlId = createSelector(
  selectCurrentTicketUndecorated,
  ticket => (ticket ? ticket.gqlId : null)
)

export const selectCurrentTicketUrl = createSelector(
  selectCurrentTicketId,
  selectHost,
  (id, host) => `https://${host}/tickets/${id}`
)

export const selectCurrentRoomUrl = createSelector(
  selectCurrentConversationId,
  selectHost,
  (conversationId, host) =>
    `https://${host}/chats?conversationId=${conversationId}`
)

export const selectCurrentConversationUrl = createSelector(
  selectIsInChat,
  selectCurrentTicketUrl,
  selectCurrentRoomUrl,
  (isInChat, currentTicketUrl, currentRoomUrl) =>
    isInChat ? currentRoomUrl : currentTicketUrl
)
